import React from 'react';
import { Box, Typography } from '@mui/material';

interface SignalIndicator {
  signalLevel: number | null; // 0-5 or null
  size?: 'small' | 'medium' | 'large';
}

const SignalIndicator: React.FC<SignalIndicator> = ({
  signalLevel,
  size = 'medium',
}) => {
  // 如果 signalLevel 為 null，則顯示灰色（無信號狀態）
  const normalizedLevel = signalLevel === null ? 0 : Math.max(0, Math.min(5, Math.round(signalLevel)));

  // 根據信號等級決定顏色
  const getSignalColor = (level: number) => {
    if (level === 0) return '#e0e0e0'; // 無信號或 null 值 - 灰色
    if (level <= 1) return '#66bb6a';
    if (level <= 2) return '#ffa726';
    if (level <= 3) return '#ffa726';
    if (level <= 4) return '#ff6b6b';
    return '#4caf50';
  };

  // 根據尺寸決定大小
  const getSizeConfig = () => {
    switch (size) {
      case 'small':
        return { width: 20, height: 12, barWidth: 4, gap: 1 };
      case 'large':
        return { width: 40, height: 24, barWidth: 8, gap: 1.5 };
      default: // medium
        return { width: 30, height: 18, barWidth: 6, gap: 1.3 };
    }
  };

  const config = getSizeConfig();
  const bars = 5; // 總共 5 個信號條

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'end', gap: config.gap }}>
        {Array.from({ length: bars }, (_, index) => {
          const barHeight = ((index + 1) / bars) * config.height;
          const isActive = index < normalizedLevel;

          return (
            <Box
              key={index}
              sx={{
                width: config.barWidth,
                height: barHeight,
                backgroundColor: isActive ? getSignalColor(normalizedLevel) : '#e0e0e0',
                borderRadius: '1px',
                transition: 'all 0.3s ease',
                opacity: isActive ? 1 : 0.3,
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default SignalIndicator;